const Ls4RiesgosInfecciones = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">

                    <h1 className="text--subtitulo p-4">Infecciones</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls4Engranajes.png" className='' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'><span className="texto--span">Las infecciones graves son m&aacute;s frecuentes en los beb&eacute;s prematuros.</span> Su sistema inmune no est&aacute; totalmente desarrollado, y corren un mayor riesgo de morir si contraen una infecci&oacute;n.</p>
                            </div>
                        </div>
                    </div>

                    <div className='col d-block d-sm-block d-md-none style--gif-2 background--baby'>
                        <img src="./img/Ls4BabyInfecciones.gif" className='img--gid-2' />
                        {/* ./img/Ls1Background.png */}
                    </div>

                    <div className='container'>
                        <div className='row d-flex ps-4 pt-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex style--burbuja py-2 align-items-center'>
                                <div className='col-3 col-ms-3 col-md-2 col-lg-1 col-xl-1'>
                                    <img src="./img/Ls4BabyMother.png" className='' />
                                </div>
                                <div className='col-9 col-ms-9 col-md-9 col-lg-9 col-xl-11'>
                                <p className='texto--burbuja--bold lh-1 ps-lg-3 ps-xl-5 m-0'>A trav&eacute;s de la leche materna, los beb&eacute;s reciben defensas para protegerse de las infecciones. <span className="texto--burbuja--bold--dorado">Es muy importante que usted amamante a su beb&eacute;.</span></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--parrafo'>Adicionalmente, existen vacunas y anticuerpos que reducen significativamente el riesgo de contraer estas infecciones. <span className="texto--span">Al ser dados de alta, es muy importante que se aplique todo el esquema de vacunaci&oacute;n e inmunizaci&oacute;n que recomiende su m&eacute;dico/a.</span></p>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>Adaptado de: <a className='texto--link' target='_blank' href='http://www.who.int/features/qa/preterm_health_challenges/en/'>http://www.who.int/features/qa/preterm_health_challenges/en/</a></p>
                    </div>

                    <h1 className="text--subtitulo p-4">Bronquiolitis</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls4BabyHarth.png" className='' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>La bronquiolitis es una infecci&oacute;n pulmonar, generalmente causada por un virus, que afecta a ni&ntilde;os menores de 2 a&ntilde;os. La causa m&aacute;s frecuente es el <span className="texto--span">virus sincitial respiratorio (VSR).</span> M&aacute;s de la mitad de los beb&eacute;s est&aacute;n expuestos a este virus en su primer a&ntilde;o de vida.<sup>1</sup></p>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--parrafo'>Los beb&eacute;s prematuros, con malformaciones del coraz&oacute;n y con enfermedades pulmonares cr&oacute;nicas que requieran ox&iacute;geno en casa, se encuentran con mayor riesgo de adquirir esta infecci&oacute;n. Puede enfermarlos seriamente y ser potencialmente fatal.<sup>2</sup></p>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>Adaptado de: 1. <a className='texto--link' target='_blank' href='http://www.mayoclinic.org/diseases-conditions/respiratory-syncytial-virus/basics/definition/con-20022497'>http://www.mayoclinic.org/diseases-conditions/respiratory-syncytial-virus/basics/definition/con-20022497</a> <br /> 2. <a className='texto--link' target='_blank' href='https://www.nlm.nih.gov/medlineplus/spanish/ency/article/000975.htm'>https://www.nlm.nih.gov/medlineplus/spanish/ency/article/000975.htm</a></p>
                    </div>

                </div>
                <div className="col-md-4 d-none d-sm-block d-sm-none d-md-block">
                    <img src="./img/Ls4BabyInfecciones.gif" className='justify-content-start style--image-baby-4' />
                </div>
            </div>
        </div>
    )
}

export default Ls4RiesgosInfecciones;